import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Select, Button, Input, Breadcrumbs, ScannerCode, Label } from '../../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../../utils/handleChangeHooks';
import { translate, showMessageToastCustom, isNullOrEmpty, formatData, getUserNameToName } from '../../../../../utils/util';
import RouteDeliveryService from '../../../../../services/RouteDeliveryService';
import RoutePickingService from '../../../../../services/RoutePickingService';

const DeliveryRouteLocationTarget = (props) => {
    const update = props.location?.state?.update;
    const [routeLocationTarget, setRouteLocationTarget] = useState(props.location?.state?.update && props.routeLocationTarget ? props.routeLocationTarget : {});
    const [pdusArray, setpdusArray] = useState([]);
    const [routeSelected, setRouteSelected] = useState({});

    useEffect(() => {
        props.getRoutes();
        if (update) {
            loadRoutePdus();
        }
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, routeLocationTarget, setRouteLocationTarget);
    };

    const loadRoutePdus = () => {
        let pdusAux = [];
        if (!routeLocationTarget?.locationTargets) {
            return;
        }
        let max = 0;
        routeLocationTarget.locationTargets.forEach((item) => {
            let sequence = item.sequence;
            let locationTarget = item.locationTarget;
            if (sequence > max) {
                max = sequence;
            }
            pdusAux.push({ sequence, locationTarget });
        });
        pdusAux.sort((a, b) => {
            return a.sequence - b.sequence
        });
        setpdusArray(pdusAux);

        let id = routeLocationTarget.routeId;
        let name = routeLocationTarget.routeCode;
        routeLocationTarget.sequence = max + 1;
        setRouteLocationTarget(routeLocationTarget);
        setRouteSelected({ id, name });
    }

    const removedRouteArray = (item) => {
        const items = pdusArray.filter((data) => data.sequence !== item.sequence);
        if (items) {
            setpdusArray(items);
        }
    }

    const scanner = (value) => {
        routeLocationTarget.locationTarget = value;
        setRouteLocationTarget(routeLocationTarget);
    };

    const addRouteLocationTarget = (item) => {
        const array = [];
        Object.assign(array, pdusArray);
        const itemSelect = item.currentTarget.options[item.currentTarget.selectedIndex];
        const name = itemSelect.text;
        const id = Number(itemSelect.value);
        setRouteSelected({ id, name });
    }

    const addListaTela = () => {
        if (!isNullOrEmpty(routeLocationTarget?.locationTarget)
            && !isNullOrEmpty(routeLocationTarget?.sequence)
            && routeLocationTarget?.sequence !== '0') {
            let locationTarget = routeLocationTarget.locationTarget;
            let sequence = Number(routeLocationTarget.sequence);

            let array = [];
            Object.assign(array, pdusArray);

            if (array.find((item) => item.sequence === sequence)) {
                showMessageToastCustom(translate('general:warning'),
                    translate('message.invalidSequence', 'delivery'),
                    3000, 'mdi mdi-alert-circle-outline red-text');
                return;
            }

            if (array.find((item) => item.locationTarget === locationTarget)) {
                showMessageToastCustom(translate('general:warning'),
                    translate('message.invalidPdu', 'delivery'),
                    3000, 'mdi mdi-alert-circle-outline red-text');
                return;
            }

            array.push({ sequence, locationTarget });
            // Ordena pela sequencia antes de exibir.
            array.sort((a, b) => {
                return a.sequence - b.sequence
            });

            routeLocationTarget.sequence = sequence + 1;
            routeLocationTarget.locationTarget = "";
            setRouteLocationTarget(routeLocationTarget);
            setpdusArray(array);
        }
    };

    const getListRouteLocationTarget = () => {
        let listResult = [];
        pdusArray.forEach((pdu) => {
            let locationTarget = pdu.locationTarget;
            let sequence = Number(pdu.sequence);
            let routeId = Number(routeSelected.id);
            listResult.push({
                routeId,
                sequence,
                locationTarget
            })
        });
        return listResult;
    }

    const redirect = () => {
        props.history.replace('./list');
    }

    const onConfirm = () => {
        if (pdusArray.length === 0 || routeSelected?.id === 0 || routeSelected?.id === '') {
            showMessageToastCustom(translate('general:warning'),
                translate('delivery:message.invalidFields'),
                3000, 'mdi mdi-alert-circle-outline red-text');

            return;
        }

        if (update) {
            props.updateRoutePdu(getListRouteLocationTarget(), () => {
                redirect();
            });
        } else {
            //getListRouteLocationTarget();
            props.addRoutePdu(getListRouteLocationTarget(), () => {
                redirect();
            });
        }
    };

    const preventPasteNegative = (e) => {
        const clipboardData = e.clipboardData || window.clipboardData;
        const pastedData = parseFloat(clipboardData.getData('text'));

        if (pastedData < 0) {
            e.preventDefault();
        }
    };

    return (
        <div>
            <Breadcrumbs id="routeLocationTargetInsert" title={{ icon: "mdi mdi-map-marker-path", label: translate('delivery:general.routePdu') }}
                subtitles={[{ icon: "mdi mdi-plus-box-outline", label: update ? translate('menu.update', 'configuration') : translate('menu.attach', 'configuration') }]} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '6px', paddingBlockEnd: '1px' }}>
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    {
                                        update ?
                                            <Input disabled={update} label={translate('delivery:fields.routes')} id="routes" name="routes" value={routeSelected?.name || ''} />
                                            : <Select
                                                id="routes"
                                                name="routes"
                                                display="description"
                                                label={translate('delivery:fields.routes')}
                                                valuefield="id"
                                                defaultValue={routeSelected?.id ? routeSelected?.id : ''}
                                                change={addRouteLocationTarget}
                                                placeHolder={translate('general:choose-one-option')}
                                                data={props.routes?.items ? props.routes?.items.map((i) => { return { id: i.id, text: i.code }; }) : []}
                                            />
                                    }
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s4">
                                    <Input
                                        required={!update}
                                        label={translate('delivery:fields.sequencial')}
                                        id="sequence"
                                        name="sequence"
                                        type="number"
                                        onPaste={preventPasteNegative}
                                        value={routeLocationTarget?.sequence || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s7">
                                    <ScannerCode className="mdi mdi-barcode-scan posfix disable" onScanner={scanner} markerCodeBar={true} />
                                    <Input
                                        required={!update}
                                        label={translate('delivery:fields.pdu')}
                                        id="locationTarget"
                                        name="locationTarget"
                                        type="text"
                                        value={routeLocationTarget?.locationTarget || ''}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            {
                                update &&
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <Label label={translate('fields.lastUpdatedBy', 'delivery')} id="updateBy" value={getUserNameToName(props.usersFromElog, routeLocationTarget?.lastUpdatedBy)} />
                                    <Label label={translate('fields.lastUpdatedOn', 'delivery')} id="updateOn" value={formatData(routeLocationTarget?.lastUpdatedOn)} />
                                </div>
                            }
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => addListaTela()} text={translate('add', 'general')} full="true" style={{ backgroundColor: '#4caf50ba' }} />
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                {
                                    pdusArray.length > 0 && pdusArray.map((item, index) => (
                                        <div key={item.sequence + index} className="no-padding col s12">
                                            <div key={item.sequence + 1} className="list sixth-text-color">
                                                <i onClick={() => removedRouteArray(item)} className={`mdi mdi-21px mdi-alpha-x-circle-outline`} />
                                                {`${item.sequence} - ${item.locationTarget}`}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.userName,
        routes: state.pickingReducer.routes,
        routeLocationTarget: state.deliveryReducer.routeLocationTarget,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getRoutes: () => {
            dispatch(RoutePickingService.getRoutes());
        },
        addRoutePdu: (routes, callback) => {
            dispatch(RouteDeliveryService.addRouteLocationTarget(routes, callback));
        },
        updateRoutePdu: (routes, callback) => {
            dispatch(RouteDeliveryService.updateRouteLocationTarget(routes, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DeliveryRouteLocationTarget)));
